export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 150,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_pdcostsOrderStatus') || '核价状态',
    field: 'pdcostsOrderStatus',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_orderNo') || '订单编号',
    field: 'orderNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '下单客户',
    field: 'custName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_endCust') || '终端客户',
    field: 'endCustName',
    width: 180,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || '客户品牌',
    field: 'x',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务人员名字',
    field: 'salesPersonName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_bizPerson') || '跟单人员',
    field: 'bizPersonName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderType') || '订单类型',
    field: 'v_orderType',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderExecuteType') || '执行方式',
    field: 'v_orderExecuteType',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_quotedMethod') || '报价方式',
    field: 'v_quotedMethod',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderAmount') || '订单成本',
    field: 'orderAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { orderAmount: value, v_currencyUnit: unit } = row
      return `${that.format(value)} ${unit}`
    },
  },
  {
    title: that.$l('table_label_ftyCostAmount') || '核算成本',
    field: 'ftyCostAmount',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { ftyCostAmount: value, v_currencyUnit: unit } = row
      return `${that.format(value)} ${unit}`
    },
  },
  {
    title: that.$l('table_label_difference') || '差异金额',
    field: 'difference',
    align: 'center',
    width: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'difference' },
  },
  {
    title: that.$l('table_label_differenceRate') || '差异率',
    field: 'differenceRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'differenceRate' },
  },
  {
    title: that.$l('table_label_managementFeeRate') || '管理费率',
    field: 'managementFeeRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { managementFeeRate: value } = row
      return `${value || 0}%`
    },
  },
  {
    title: that.$l('table_label_managementFee') || '管理费',
    field: 'managementFee',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { managementFee: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_profitRate') || '毛利率',
    field: 'profitRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { profitRate: value } = row
      return `${value || 0}%`
    },
  },
  {
    title: that.$l('table_label_profit') || '毛利',
    field: 'profit',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { profit: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_vatRate') || '增值税率',
    field: 'vatRate',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { vatRate: value } = row
      return `${value || 0}%`
    },
  },
  {
    title: that.$l('table_label_vat') || '增值税',
    field: 'vat',
    align: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { vat: value } = row
      return that.format(value)
    },
  },
  {
    title: that.$l('table_label_factoryPaymentTerms') || '工厂付款条件',
    field: 'v_factoryPaymentTerms',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDay') || '交货日期',
    field: 'deliveryDay',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_orderRemark') || '订单备注说明',
    field: 'orderRemark',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
